
<div class="site-panel">
    <v-form ref="form">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab">
                <c-flip-card
                    v-model = "firstFlipped"
                    :top    = "6"
                    color   = "primary--text"
                >
                    <template slot="front">
                        <div class="w-100">
                            <f-title title="Kunde">
                            </f-title>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <c-customer-select
                                        label         = "Kunde"
                                        v-model       = "site.customer"
                                        :readonly     = "readonly || !isUnitAdmin"
                                        :clearable    = "false"
                                        :my-customers = "false"
                                        :lim-customer = "false"
                                        :rules        = "[ requiredRule ]"
                                        @change       = "onCustomer"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        label          = "Bereich"
                                        :readonly      = "readonly"
                                        v-model        = "site.branch"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        label          = "Mieter des Objekts"
                                        :readonly      = "readonly"
                                        v-model        = "site.tentant"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>

                            <f-title title="Identifikation"  class="mt-5" style="margin-bottom: 13px;" />
                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2 col-4">
                                    <f-read-only-field
                                        label  = "HC ID"
                                        :value = "site.id"
                                        style  = "margin-top: 1px"
                                        filled
                                    />
                                </v-col>
                                <v-col class="no-frame pl-2 col">
                                    <v-text-field
                                        label          = "Externe ID"
                                        :readonly      = "readonly"
                                        v-model        = "site.externalId"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        label          = "Fabrik-Nr."
                                        :readonly      = "readonly"
                                        v-model        = "site.fabricNo"
                                        :rules         = "[ requiredRule ]"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame mt-5">
                                <v-textarea
                                    label          = "Synonyme"
                                    class          = "pt-0"
                                    v-model        = "synonyms"
                                    :readonly      = "readonly"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    rows="3"
                                    no-resize
                                />
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        label          = "Bezeichnung"
                                        :readonly      = "readonly"
                                        v-model        = "site.description"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>

                            <f-title class="mt-2" title="Status" />

                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2">
                                    <f-enum-select
                                        v-model   = "site.status"
                                        label     = "Anlage"
                                        module    = "msd"
                                        :readonly = "readonly"
                                        type      = "siteStatus"
                                    />
                                </v-col>
                                <v-col class="no-frame pl-2">
                                    <f-date-picker
                                        label     = "unit.core.warranty"
                                        v-model   = "site.warranty"
                                        :readonly = "readonly"
                                        :time     = "false"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </template>

                    <template slot="back">
                        <div class="w-100">
                            <c-unit-lg-smart-card
                                :site = "site"
                            />

                            <f-title title="Aufkleber" class="mt-5" />
                            <v-row class="no-frame mt-4">
                                <c-unit-sticker-list
                                    :sticker = "site.sticker"
                                />
                            </v-row>
                        </div>
                    </template>
                </c-flip-card>
            </v-col>
            <v-col class="main-middlle-col modal-tab">
                <c-flip-card v-model="middleFlipped" :top="6" color="primary--text">
                    <template slot="front">
                        <div class="w-100">

                            <f-title title="Standort" />

                            <v-row class="no-frame">
                                <v-col class="col-3 no-frame pr-2">
                                    <v-text-field
                                        label          = "PLZ"
                                        :readonly      = "readonly"
                                        v-model        = "site.zip"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                                <v-col class="col-9 no-frame pl-2">
                                    <v-text-field
                                        label="Stadt"
                                        :readonly      = "readonly"
                                        v-model        = "site.city"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>

                            <v-row class="no-frame">
                                <v-text-field
                                    label="Strasse"
                                    :readonly      = "readonly"
                                    v-model        = "site.street"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-row>

                            <v-row class="no-frame">
                                <v-text-field
                                    label="Adresszusatz"
                                    :readonly      = "readonly"
                                    v-model        = "site.addressExtension"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-row>

                            <v-row class="no-frame">
                                <f-enum-select
                                    v-model   = "site.country"
                                    label     = "Land"
                                    module    = "msd"
                                    :readonly = "readonly"
                                    type      = "countries"
                                />
                            </v-row>

                            <v-row class="no-frame">
                                <v-col class="no-frame mr-2">
                                    <v-text-field
                                        label          = "Längengrad"
                                        :readonly      = "readonly"
                                        v-model        = "site.longitude"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                                <v-col class="no-frame ml-2">
                                    <v-text-field
                                        label          = "Breitengrad"
                                        :readonly      = "readonly"
                                        v-model        = "site.latidute"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>

                            <f-title class="mt-3" title="Verwaltungseinheiten" />
                            <v-row class="no-frame">
                                <v-text-field
                                    label          = "Buchungskreis"
                                    :readonly      = "readonly"
                                    v-model        = "site.ve"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-row>
                            <v-row class="no-frame">
                                <v-text-field
                                    label          = "Wirtschaftseinheit"
                                    :readonly      = "readonly"
                                    v-model        = "site.ve2"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-row>
                            <v-row class="no-frame">
                                <v-text-field
                                    label          = "VE3"
                                    :readonly      = "readonly"
                                    v-model        = "site.ve3"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-row>

                            <f-title class="mt-4" title="Equipmentnummer" />
                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2">
                                    <v-text-field
                                        label          = "Wartungsnehmer"
                                        :readonly      = "readonly"
                                        v-model        = "site.equipmentNoMnt"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                                <v-col class="no-frame pl-2">
                                    <v-text-field
                                        label          = "ZÜS"
                                        :readonly      = "readonly"
                                        v-model        = "site.equipmentNoZus"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-checkbox
                                        v-model      = "site.zusNotRequired"
                                        label        = "Kein ZÜS erforderlich"
                                        :ripple      = "false"
                                        class        = "mt-0"
                                        :hide-details = "true"
                                        :readonly    = "readonly"
                                        dense
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    <template slot="back">
                        <div class="w-100">
                        </div>
                    </template>
                </c-flip-card>
            </v-col>
            <v-col class="main-middlle-last-col modal-tab">
                <iframe :key="mapurl" v-if="site.latidute" :src="mapurl" style="border:0; width: 100%; height: 100%" allowfullscreen></iframe>
            </v-col>
        </v-row>
    </v-form>
</div>
